/**
 * Created by yougen on 3/25/15.
 */
module.exports = {
      email: 'example@example.com',
      fax: '0000-8888888',
      firstName: 'Example',
      lastName: 'Example',
      phone: '0000-8888888',
      mobile: '0000-12345678911'
};
